import React, { useState, useCallback, useEffect } from 'react';

import "../styles/footer.css";

const cdnURL = process.env.REACT_APP_CDN_URL;

const Footer = ({}) => {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    
    // Handle desktop/mobile view
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [])
    
    return (
        <footer className="footer">
            <div className="footer-top">
                <div className="footer-social">
                <span className="follow-text">FOLLOW US ON</span>
                <a href={`https://www.instagram.com/xoxmalaysia`} target="_blank" rel="noopener noreferrer" ><img src={`${cdnURL}/images/footer/icon_instagram.svg`} alt="Instagram" /></a>
                <a href={`https://www.facebook.com/xoxmalaysia/`} target="_blank" rel="noopener noreferrer"><img src={`${cdnURL}/images/footer/icon_facebook.svg`} alt="Facebook" /></a>
                <a href={`https://twitter.com/xox_malaysia?lang=en`} target="_blank" rel="noopener noreferrer"><img src={`${cdnURL}/images/footer/icon_xtwitter.svg`} alt="X" /></a>
                <a href={`https://www.youtube.com/channel/UChxtgedNAHD-DlKkuGiYFfg`} target="_blank" rel="noopener noreferrer"><img src={`${cdnURL}/images/footer/icon_youtube.svg`} alt="YouTube" /></a>
                <a href={`https://www.linkedin.com/company/xox-bhd/mycompany/`} target="_blank" rel="noopener noreferrer"><img src={`${cdnURL}/images/footer/icon_linkedin.svg`} alt="LinkedIn" /></a>
                </div>

                <div className="footer-apps">
                <a href={`https://play.google.com/store/apps/details?id=com.xoxblackapp&hl=en`} target="_blank" rel="noopener noreferrer"><img src={`${cdnURL}/images/footer/icon_download_app-cropped_google play.svg`} alt="GoogleDownload" /></a>
                <a href={`https://apps.apple.com/my/app/xox-black/id1458845942?l=EN`} target="_blank" rel="noopener noreferrer"><img src={`${cdnURL}/images/footer/icon_download_app-cropped_AppStore.svg`} alt="AppStoreDownload" /></a>
                <a href={`https://appgallery.huawei.com/app/C101429711`} target="_blank" rel="noopener noreferrer" ><img src={`${cdnURL}/images/footer/icon_download_app-cropped_huaweiAppGallery.svg`} alt="HuaweiDownload" /></a>
                </div>
            </div>

            <div className={screenWidth < 600 ? 'footer-bottom-mobile' : 'footer-bottom'}>
                <div className="footer-links">
                    <a href={`/terms-condition`} target="_blank" rel="noopener noreferrer" style={{paddingLeft:"0px"}}>Terms & Conditions</a> | 
                    <a href={`/privacystatement`} target="_blank" rel="noopener noreferrer" >Privacy Notice</a> | 
                    <a href={`/scamalert`}target="_blank" rel="noopener noreferrer" >Scam Alert</a> | 
                    <a href={`/notifications`}target="_blank" rel="noopener noreferrer" >MCMC Notifications</a>
                </div>
                {/* <span className="footer-copy">
                © 2026 XOX Digital Sdn Bhd 200701005355 (763354-U)
                XOX AJL License Number (AJL 932178). All Rights Reserved.
                </span> */}
                <span className="footer-copy" style={{ lineHeight: screenWidth < 600 ? '10px' : undefined, textAlign: screenWidth < 600 ? 'left' : 'right' }}>
                    © {new Date().getFullYear()} XOX BHD (Co. No. 201001016682 (0900384-X)). This website is owned and operated by XOX BHD and its subsidiary: XOX DIGITAL Sdn Bhd (Co. No. 200701005355 (0763354-U)).
                    {screenWidth < 600 ? <></> : <br />}
                    AJL Holder: XOX DIGITAL Sdn Bhd (AJL 932519). All Rights Reserved. Hakcipta Terpelihara.
                </span>
            </div>
        </footer>

    );
};


export default Footer;
